import React, { Component } from 'react'

import data from '../_main_data'

class SocialLinks extends Component {
    align() {
        if (this.props.right || this.props.right === true) {
            return 'text-right'
        }
    }

    render() {
        const { facebook, linkedin, twitter, youtube, instagram } = data.socialLinks
        const css = this.props.css ? this.props.css : ''

        return (
            <div className={`social-links ${this.align()} ${css}`}>
                <ul>
                    {facebook && (<li>
                        <a target="_blank" href={facebook}><i className="fab fa-facebook-square" rel="noopener noreferrer" /></a>
                    </li>)}
                    {twitter && (<li>
                        <a target="_blank" href={twitter}><i className="fab fa-twitter-square" rel="noopener noreferrer" /></a>
                    </li>)}
                    {linkedin && (<li>
                        <a target="_blank" href={linkedin}><i className="fab fa-linkedin" rel="noopener noreferrer" /></a>
                    </li>)}
                    {youtube && (<li>
                        <a target="_blank" href={youtube}><i className="fab fa-youtube" rel="noopener noreferrer" /></a>
                    </li>)}
                    {instagram && (<li>
                        <a target="_blank" href={instagram}><i className="fab fa-instagram" rel="noopener noreferrer" /></a>
                    </li>)}
                </ul>
            </div>
        )
    }
}

export default SocialLinks


// WEBPACK FOOTER //
// ./src/components/SocialLinks.js